import Swal from 'sweetalert2';
import { isSafeAreaDisplay } from '@/service/isSafeAreaDisplay';

export const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  padding: isSafeAreaDisplay()
    ? '50px 1.25rem 1.25rem 1.25rem'
    : '1.25rem',
});
